import React from 'react';

const NotYetImplemented = () => <div>Bienvenue sur PST Formations</div>;

NotYetImplemented.propTypes = {};

export { NotYetImplemented };
